import { ModalContainer, SectionHeader } from "../../../components";
import { HookFormSelect, SubmitButton, TextInput } from "../../../hook-form";
import { IMoveFundsFormViewProps } from "./MoveFundsForm";
import { currencies } from "../../../constants";
import { Fragment } from "react";

export const View = ({
  isLoadingMoveFunds: isLoadingCreateBatchBankTransfer,
  isLoadingPgwTopUpBankDetails,
  pgwTopUpBankDetails,
  closeModal,

  // bankTransfersFieldArray,
  // removeBankTransferByIndex,
  // appendNewBankTransfer,
  // updateBankTransferByIndex,

  formValues,
  control,
  errors,
  handleSubmit,
  register,
}: IMoveFundsFormViewProps) => {
  const swappPaymentGateways = [
    "flutterwave",
    "gtSquad",
    "monnify",
    "paystack",
    "zenith",
  ];

  return (
    <form onSubmit={handleSubmit}>
      <ModalContainer
        isModalOpen={true}
        closeModal={closeModal}
        fullscreen
        modalHeader={
          <SectionHeader
            title="Inter-Provider Transfers"
            subtitle="Transfer funds across SwitchApp Payment Providers."
            renderRight={
              <div className="flex-container justify-content--end mt-5">
                <div className="flex-container">
                  <SubmitButton
                    kind="primary"
                    // size="sm"
                    className="ml-5"
                    // disabled={formInvalid}
                    isLoading={isLoadingCreateBatchBankTransfer}
                    title={"Send Funds"}
                  >
                    Initiate Transfers
                  </SubmitButton>
                </div>
              </div>
            }
          />
        }
      >
        <div className="create-batch-transfer-container">
          <div className="flex-container flex-break--small">
            <div className="flex-box">
              <TextInput
                name="title"
                label="Title (Optional)"
                placeholder="e.g. Moving funds for payouts"
                infoIconText="Title for the batch of funds moved"
                type="text"
                register={register}
                errors={errors}
              />
            </div>

            {/* <div className="flex-box"/> */}
          </div>

          <div className="flex-container flex-break--small align-items--start">
            <div className="flex-box mr-md-5">
              <HookFormSelect
                name="source_currency"
                label="Source Wallet/Currency"
                infoIconText="Your account balance to make transfer from eg NGN - Account, USD - Account. If the amount is not in the transfer currency, we will convert it. "
                selectItems={currencies.map((cur) => ({
                  text: `${cur.text} - (${cur.currencySymbol})`,
                  value: cur.value,
                }))}
                register={register}
                errors={errors}
              />
            </div>

            <div className="flex-box">
              <TextInput
                name="batch_reference"
                label="Batch Reference"
                infoIconText="Batch reference for this movement of funds"
                type="text"
                register={register}
                errors={errors}
              />
            </div>
          </div>

          {formValues.shadow_bank_transfers.map((field, index) => {
            return (
              <Fragment key={`${field.reference}`}>
                <div className="flex-container flex-break--small">
                  <div className="flex-box mr-md-5">
                    <HookFormSelect
                      name={`shadow_bank_transfers.${index}.source_gateway_code`}
                      label="From Gateway"
                      infoIconText="The source gateway to move funds from"
                      selectItems={swappPaymentGateways.map((gw) => ({
                        text: `${gw} - (${gw})`,
                        value: gw,
                      }))}
                      register={register}
                      errors={errors}
                    />
                  </div>

                  <div className="flex-box">
                    <HookFormSelect
                      name={`shadow_bank_transfers.${index}.recipient_gateway_code`}
                      label="To Gateway"
                      infoIconText="The source gateway to move funds from"
                      selectItems={swappPaymentGateways.map((gw) => ({
                        text: `${gw} - (${gw})`,
                        value: gw,
                      }))}
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>

                <div className="flex-container flex-break--small align-items--start">
                  <div className="flex-box mr-md-5">
                    <TextInput
                      name={`shadow_bank_transfers.${index}.amount`}
                      label="Amount"
                      infoIconText="Amount to move across gateways"
                      type="text"
                      register={register}
                      errors={errors}
                    />
                  </div>

                  {/* <div className="flex-box">
                    <TextInput
                      name={`shadow_bank_transfers.${index}.xxxxxx`}
                      label="xxxxxx"
                      infoIconText="xxxxxx"
                      type="text"
                      register={register}
                      errors={errors}
                    />
                  </div> */}
                </div>

                <div className="flex-container flex-break--small align-items--start">
                  <div className="flex-box">
                    <HookFormSelect
                      name={`shadow_bank_transfers.${index}.top_up_wallet_details_id`}
                      label="Top-Up Bank Details"
                      infoIconText="Bank details where the funds should be transferred to"
                      selectItems={pgwTopUpBankDetails.map((bnk) => ({
                        // text: `${bnk.bank_name.toUpperCase()} | ${bnk.account_number} (${bnk.account_name}) [${bnk.gateway_code}--${bnk.currency}--${bnk.merchant_name}]`,
                        text: `${bnk.bank_name.toUpperCase()} | ${
                          bnk.account_number
                        } (${bnk.account_name})`,
                        value: bnk.id,
                      }))}
                      showSkeleton={isLoadingPgwTopUpBankDetails}
                      register={register}
                      errors={errors}
                    />
                  </div>

                  <div className="">
                    <TextInput
                      name={`shadow_bank_transfers.${index}.account_name`}
                      label=""
                      type="hidden"
                      register={register}
                      errors={errors}
                    />
                    <TextInput
                      name={`shadow_bank_transfers.${index}.account_number`}
                      label=""
                      type="hidden"
                      register={register}
                      errors={errors}
                    />

                    <TextInput
                      name={`shadow_bank_transfers.${index}.bank_name`}
                      label=""
                      type="hidden"
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </Fragment>
            );
          })}

          <TextInput
            name="description"
            label="Batch description (Optional)"
            placeholder="e.g. Performance bonuses were included in the salaries this month"
            infoIconText="A general description for the transfers in this batch (Optional)"
            type="text"
            register={register}
            errors={errors}
          />
        </div>
      </ModalContainer>
    </form>
  );
};
